import { Checkbox, Loader, Stack, Text } from '@mantine/core';
import { useAppsList } from '../../queries/apps';
import { useSetUserAppAccess, useUserAppAccess } from '../../queries/user-app-access';

interface Props {
  userId: string;
}

/** Superadmin control: which apps (`apps.key`) a given user may sign into. */
export function UserAppAccess({ userId }: Props) {
  const appsQ = useAppsList();
  const accessQ = useUserAppAccess(userId);
  const setAccessM = useSetUserAppAccess();

  const apps = appsQ.data ?? [];
  const appKeys = accessQ.data ?? [];

  if (appsQ.isLoading || accessQ.isLoading) {
    return <Loader size="sm" />;
  }

  function toggle(key: string, checked: boolean) {
    const next = checked ? [...new Set([...appKeys, key])] : appKeys.filter((k) => k !== key);
    setAccessM.mutate({ userId, appKeys: next });
  }

  return (
    <Stack gap={4}>
      <Text size="sm" fw={500}>
        App access
      </Text>
      {apps.length === 0 ? (
        <Text size="sm" c="dimmed">
          No apps configured
        </Text>
      ) : (
        apps.map((a) => (
          <Checkbox
            key={a.key}
            label={a.name}
            checked={appKeys.includes(a.key)}
            onChange={(e) => toggle(a.key, e.currentTarget.checked)}
            disabled={setAccessM.isPending}
          />
        ))
      )}
    </Stack>
  );
}
